export const inputOptions = {
  classes: {
    base: 'input__generic',
    empty: 'input__generic ',
    invalid: 'input__generic error',
  },
  placeholder: '',
};
